import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { ThreeDots } from "react-loader-spinner"

import _ from "lodash"
import { Dialog } from "primereact/dialog"

import { Button, DropDownField } from "../../../helpers"

import CreateSellerPO from "../Components/CreateSellerPO/index"
import NewSellerPOModalData from "./NewSellerPOModalData"

import { setSelectedBuyerPODocNo, setSelectedBuyerPOId } from "../../../services/redux/reducers/Requirement/requirement"

import { getDateString } from "../../../utils"


const SellerPoModal = (props) => {
    const { selectedReq, buyerPOs, visibleSellerpo, setVisibleSellerpo, approvalInstances, buyerQuoteItems, buyerPOItems, materialDetails, sellerCompanyDetails, sellerReqs } = props
   
    const [isLoading, setIsLoading] = useState(false)
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [visibleCreateSellerPO, setVisibleCreateSellerPO] = useState(false)

    const [relatedBuyerPOs, setRelatedBuyerPOs] = useState([])
    const [sellerPOs, setSellerPOs] = useState([])
    const [sellerPOItems, setSellerPOItems] = useState([])

    const sellerPOData = useSelector(state => state.requirements.sellerPOData)
    const sellerReqData = useSelector(state => state.requirements.sellerReqData)
    const buyerPOData = useSelector(state => state.requirements.buyerPOData)
    const materialProductsData = useSelector(state => state.requirements.materialProductsData)
    const selectedBuyerPOId = useSelector(state => state.requirements.selectedBuyerPOId)

    const dispatch = useDispatch()

    useEffect(()=>{
        return () => {
            dispatch(setSelectedBuyerPOId(null))
        }
    }, [])
    
    useEffect(() => {
        let relatedBuyerPOsData = buyerPOs?.filter(eachBuyerPO => eachBuyerPO?.buyerReqId === selectedReq?.buyerReqId && [3, 4, 6].includes(eachBuyerPO.statusId))
        relatedBuyerPOsData  = relatedBuyerPOsData?.map(eachBuyerPO => {
            let createdAtString = getDateString(eachBuyerPO?.createdAt)
            return {...eachBuyerPO, docNo: `${eachBuyerPO?.docNo} (${createdAtString})`}
        })

        relatedBuyerPOsData = _.sortBy(relatedBuyerPOsData, "createdAt")
        if (relatedBuyerPOsData?.length > 1){
            setRelatedBuyerPOs(relatedBuyerPOsData)
            dispatch(setSelectedBuyerPOId(null))
            setSellerPOs([])
            setSellerPOItems([])
        }else {
            if(relatedBuyerPOsData){
                setRelatedBuyerPOs(relatedBuyerPOsData)
                dispatch(setSelectedBuyerPOId(relatedBuyerPOsData[0]?.buyerPOId))
            }
        }
    }, [selectedReq])

    useEffect(() => {
        if(selectedBuyerPOId){
            getSellerPO()
        }
    }, [selectedBuyerPOId])

    const getSellerPO = async () => {
        if (selectedBuyerPOId){
            //setIsLoading(true)

            let relatedSellerPOs = props.sellerPOs?.filter(eachSellerPO => parseInt(eachSellerPO?.buyerPOId) === selectedBuyerPOId)
            const relatedSellerPOItems = props.sellerPOItems.filter(eachSellerPOItem => parseInt(eachSellerPOItem.buyerPOId) === selectedBuyerPOId)

            relatedSellerPOs = _.orderBy(relatedSellerPOs, ['createdAt'], ['desc'])

            setSellerPOs(relatedSellerPOs)
            setSellerPOItems(relatedSellerPOItems)
            //setIsLoading(false)
        }
    }

    const renderHeader = () => {
        return (
            <div className="flex flex-row justify-content-between">
                <p>SELLER PURCHASE ORDER</p>
                <div className="col-7 flex flex-row justify-content-end align-items-center py-0">
                    <span style={{fontSize:"13px", marginRight: "5px"}} >Buyer PO No: </span>
                    <span className=""><DropDownField options={relatedBuyerPOs} optionLabel="docNo" optionValue="buyerPOId" value={selectedBuyerPOId} className="document-select-dropdown" onChange={e => dispatch(setSelectedBuyerPOId(e.target.value))}/></span>
                    <Button className="ml-2" onClick={() => handleCreateSellerPO()} disabled={!selectedBuyerPOId} permissions={[18]}>Create Seller PO</Button>
                </div>
            </div>
        )
    }

    const handleCreateSellerPO = () => {
        const selectedBuyerPO = buyerPOs.find(eachBuyerPO => eachBuyerPO.buyerPOId === selectedBuyerPOId)
        setVisibleCreateSellerPO(true)
        dispatch(setSelectedBuyerPODocNo(selectedBuyerPO.docNo))
    }

    const handleOnHideDialog = () => {
        dispatch(setSelectedBuyerPOId(null))
        setRelatedBuyerPOs([])
        setSellerPOs([])
        setVisibleSellerpo(false)
    }

    return(
        <>
            <Dialog className="sellerpo-dialog" style={{ width: '90vw', height: '85vh'}} header={renderHeader} visible={visibleSellerpo} onHide={() => handleOnHideDialog()}>
                <div className="sellerpo-modal">
                    {
                        !selectedBuyerPOId && 
                        <div className="flex justify-content-center">
                            <p className="font-bold">Please select the buyer po doc number.</p>
                        </div>
                    }
                    {
                        isLoading ? 
                            (
                                <div className="flex justify-content-center h-full">
                                    <ThreeDots height="50" width="50" radius="5"color="#00baac" ariaLabel="three-dots-loading" visible={true} /> 
                                </div>
                            ) : (
                                <>
                                    {
                                        sellerPOs?.length === 0 && selectedBuyerPOId ? 
                                        (
                                            <div className="flex justify-content-center">
                                                <p className="font-bold">Seller POs has not found for the selected buyer po.</p>
                                            </div>
                                        ) : 
                                        (
                                        sellerPOs?.map(eachSellerPO => {
                                            const relatedBuyerPOItems = buyerPOItems.filter(eachBuyerPOItem => eachBuyerPOItem.buyerPOId === eachSellerPO.buyerPOId)
                                            const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqId === eachSellerPO.buyerReqId)
                                            const relatedApprovalInstances = approvalInstances.filter(eachApprovalInstance => eachApprovalInstance.docNo === eachSellerPO.docNo)
                                            const relatedSellerPOItems = sellerPOItems.filter(eachSellerPOItem => eachSellerPOItem.sellerPOId === eachSellerPO.sellerPOId)
                                            const releatedSellerCompanyDetails = sellerCompanyDetails.find(eachSellerCompany => eachSellerCompany.companyId === eachSellerPO.companyId)
                                            const relatedSellerReq = sellerReqs.find(eachSellerReq => eachSellerReq.sellerReqId === eachSellerPO.sellerReqId)
                                            return (
                                                <NewSellerPOModalData 
                                                    key={`sellerPO-list-view-${eachSellerPO.sellerPOId}`}
                                                    sellerPOId={eachSellerPO.sellerPOId} 
                                                    sellerReq={relatedSellerReq}
                                                    sellerReqs={sellerReqData?.sellerReqs}
                                                    sellerReqItems={sellerReqData?.sellerReqItems}
                                                    selectedReq={selectedReq}
                                                    materialDetails={materialDetails}
                                                    approvalInstances={relatedApprovalInstances}
                                                    buyerQuoteItems={relatedBuyerQuoteItems}
                                                    buyerPOItems={relatedBuyerPOItems}
                                                    isLoading={isPageLoading}
                                                    setIsLoading={setIsPageLoading}
                                                    sellerPO={eachSellerPO}
                                                    sellerPOItems={relatedSellerPOItems}
                                                    sellerCompanyDetails={releatedSellerCompanyDetails}
                                                />
                                            )
                                        })
                                    )
                                    }
                                </>
                            )
                    }
                </div>  
            </Dialog>

            {
                visibleCreateSellerPO && 
                    <CreateSellerPO 
                        sellerReqData={sellerReqData} 
                        buyerPOData={buyerPOData} 
                        selectedReq={selectedReq} 
                        setIsPageLoading={setIsPageLoading} 
                        sellerPOData={sellerPOData} 
                        materilProductsData={materialProductsData} 
                        setVisibleCreateSellerPO={setVisibleCreateSellerPO} 
                        visibleCreateSellerPO={visibleCreateSellerPO} 
                    />
            }
        </>
    )
}

export default SellerPoModal;